import React, { Component, FormEvent } from "react";
import { History } from "history";
import {
    Row, Col, Box, Alerta, TipoAlerta, CampoTexto, PosicaoTituloCampoTexto, Abas, AbasLista, Combo,
    PosicaoTituloCombo, Botao, TipoBotao, Form
} from "@intechprev/componentes-web";

import { Page, Login } from "..";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { DadosPessoaisService, DependenteService, EstadoCivilService, SexoService, EnderecoPessoaService, MunicipioService, GrauInstrucaoService, ContaBancariaService } from "../../services";
import { EstadoCivilEntidade, ListaSexoEntidade, PessoaFisicaEntidade, EnderecoPessoaEntidade, MunicipioEntidade, GrauInstrucaoEntidade, ContaBancariaEntidade } from "../../entidades";
import { PessoaFisicaService } from "../../services/PessoaFisicaService";


interface Props {
    history?: History;
}

interface State {
    dados: any,
    dependentes: Array<any>,
    dadosSexo: Array<ListaSexoEntidade>,
    dadosEstadoCivil: Array<EstadoCivilEntidade>,
    dadospessoaFisica: PessoaFisicaEntidade
    dadosEndereco: EnderecoPessoaEntidade,
    dadosMunicipio: Array<MunicipioEntidade>,
    dadosGrauInstrucao: Array<GrauInstrucaoEntidade>,
    dadosBancarios: ContaBancariaEntidade,
}

export class AlteracaoCadastral extends React.Component<Props, State> {

    private page = React.createRef<Page>();
    private form = React.createRef<Form>();
    private alert = React.createRef<Alerta>();

    constructor(props: Props) {
        super(props);

        this.state = {
            dados: {},
            dependentes: [],
            dadosSexo: new Array<ListaSexoEntidade>(),
            dadosEstadoCivil: new Array<EstadoCivilEntidade>(),
            dadospessoaFisica: new PessoaFisicaEntidade(),
            dadosEndereco: new EnderecoPessoaEntidade(),
            dadosMunicipio: new Array<MunicipioEntidade>(),
            dadosGrauInstrucao: new Array<GrauInstrucaoEntidade>(),
            dadosBancarios: new ContaBancariaEntidade(),
        };
    }

    componentDidMount = async () => {
        await this.page.current.loading(true);

        await this.buscarDados();
        await this.buscarPessoaFisica();
        await this.buscarEnderecoPessoa();
        await this.buscarMunicipios();
        await this.buscarDadosBancarios();

        await this.page.current.loading(false);
    }

    buscarDados = async () => {
        var dados = await DadosPessoaisService.Buscar();
        var estadocivil = await EstadoCivilService.Buscar();
        var sexo = await SexoService.Buscar();
        var grauinstrucao = await GrauInstrucaoService.BuscarTodos();
        this.setState({
            dados,
            dadosSexo: sexo,
            dadosEstadoCivil: estadocivil,
            dadosGrauInstrucao: grauinstrucao,
        });
    }

    buscarPessoaFisica = async () => {
        var pessoafisica = await PessoaFisicaService.BuscarPorCdPessoa(this.state.dados.CD_PESSOA);

        this.setState({
            dadospessoaFisica: pessoafisica,
        });
    }

    buscarEnderecoPessoa = async () => {
        var endereco = await EnderecoPessoaService.BuscarPorCdPessoa(this.state.dados.CD_PESSOA);

        this.setState({
            dadosEndereco: endereco,
        });
    }

    buscarMunicipios = async () => {
        var municipio = await MunicipioService.Buscar();

        this.setState({
            dadosMunicipio: municipio,
        });
    }

    buscarDadosBancarios = async () => {
        var dadosbancarios = await ContaBancariaService.BuscarPorCdPessoa(this.state.dados.CD_PESSOA);

        this.setState({
            dadosBancarios: dadosbancarios,
        });
    }

    validar = async () => {
        await this.alert.current.limparErros();
        await this.form.current.validar();

        if (this.form.current.state.valido) {
            this.salvar();
        }
    }

    salvar = async () => {
        try {
            PessoaFisicaService.Atualizar(this.state.dadospessoaFisica);
            EnderecoPessoaService.Atualizar(this.state.dadosEndereco);
            toast.info("Registro Salvo com sucesso!");
        }
        catch {
            toast.error("Erro ao tentar salvar os seus dados!");
        }
    }


    render() {
        return (
            <Page {...this.props} ref={this.page}>
                <Form ref={this.form}>
                    <Row>
                        <Col tamanho={"12"} className={"col-lg-12"}>
                            <Box titulo={"Dados Pessoais"}>
                                <Row>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"NO_PESSOA"}
                                            desabilitado
                                            valor={this.state.dadospessoaFisica.NO_PESSOA}
                                            titulo={"Nome"}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Combo
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"IR_SEXO"}
                                            titulo={"Sexo"}
                                            desabilitado
                                            valor={this.state.dadospessoaFisica.IR_SEXO}
                                            padrao={this.state.dadospessoaFisica.IR_SEXO}
                                            opcoes={this.state.dadosSexo}
                                            nomeMembro={"DS_SEXO"}
                                            valorMembro={"IR_SEXO"}
                                            posicaoTitulo={PosicaoTituloCombo.cima}
                                            tituloClassName={"text-primary"}
                                        />
                                    </Col>
                                    <Col>
                                        <Combo
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"CD_ESTADO_CIVIL"}
                                            titulo={"Estado Civil"}
                                            desabilitado
                                            valor={this.state.dadospessoaFisica.CD_ESTADO_CIVIL}
                                            padrao={this.state.dadospessoaFisica.CD_ESTADO_CIVIL}
                                            opcoes={this.state.dadosEstadoCivil}
                                            nomeMembro={"DS_ESTADO_CIVIL"}
                                            valorMembro={"CD_ESTADO_CIVIL"}
                                            posicaoTitulo={PosicaoTituloCombo.cima}
                                            tituloClassName={"text-primary"}
                                        />
                                    </Col>
                                    <Col>
                                        <Combo
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"CD_GRAU_INSTRUCAO"}
                                            titulo={"Grau Instrução"}
                                            obrigatorio={false}
                                            valor={this.state.dadospessoaFisica.CD_GRAU_INSTRUCAO}
                                            opcoes={this.state.dadosGrauInstrucao}
                                            nomeMembro={"DS_GRAU_INSTRUCAO"}
                                            valorMembro={"CD_GRAU_INSTRUCAO"}
                                            posicaoTitulo={PosicaoTituloCombo.cima}
                                            tituloClassName={"text-primary"}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"DT_NASCIMENTO"}
                                            desabilitado
                                            titulo="DATA NASCIMENTO"
                                            valor={this.state.dadospessoaFisica.DT_NASCIMENTO}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"NR_CPF"}
                                            desabilitado
                                            titulo="CPF"
                                            valor={this.state.dadospessoaFisica.NR_CPF}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"NO_PAI"}
                                            desabilitado
                                            titulo="NOME DO PAI"
                                            valor={this.state.dadospessoaFisica.NO_PAI}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadospessoaFisica"
                                            nome={"NO_MAE"}
                                            desabilitado
                                            titulo="NOME DA MÃE"
                                            valor={this.state.dadospessoaFisica.NO_MAE}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>

                            </Box>
                        </Col>
                    </Row>

                    <Row>
                        <Col tamanho={"12"} className={"col-lg-12"}>
                            <Box titulo={"Endereço Residencial"}>
                                <Row>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"DS_ENDERECO"}
                                            obrigatorio
                                            titulo="Endereço"
                                            valor={this.state.dadosEndereco.DS_ENDERECO}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"NR_ENDERECO"}
                                            obrigatorio={false}
                                            titulo="Número"
                                            valor={this.state.dadosEndereco.NR_ENDERECO}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"DS_COMPLEMENTO"}
                                            titulo="Complemento"
                                            valor={this.state.dadosEndereco.DS_COMPLEMENTO}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima} />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"NO_BAIRRO"}
                                            obrigatorio
                                            titulo="Bairro"
                                            valor={this.state.dadosEndereco.NO_BAIRRO}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Combo
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"CD_MUNICIPIO"}
                                            titulo={"Cidade"}
                                            obrigatorio={true}
                                            valor={this.state.dadosEndereco.CD_MUNICIPIO}
                                            padrao={this.state.dadosEndereco.CD_MUNICIPIO}
                                            opcoes={this.state.dadosMunicipio}
                                            nomeMembro={"DS_MUNICIPIO"}
                                            valorMembro={"CD_MUNICIPIO"}
                                            posicaoTitulo={PosicaoTituloCombo.cima}
                                            tituloClassName={"text-primary"}
                                        />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"CD_UF"}
                                            titulo="Uf"
                                            obrigatorio={true}
                                            valor={this.state.dadosEndereco.CD_UF}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima} />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"NR_CEP"}
                                            obrigatorio
                                            titulo="Cep"
                                            valor={this.state.dadosEndereco.NR_CEP}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"NR_FONE"}
                                            titulo="Fone"
                                            valor={this.state.dadosEndereco.NR_FONE}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima} />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"NR_CELULAR"}
                                            titulo="Celular"
                                            valor={this.state.dadosEndereco.NR_CELULAR}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima} />
                                    </Col>
                                    <Col>
                                        <CampoTexto
                                            contexto={this}
                                            parent="dadosEndereco"
                                            nome={"NO_EMAIL"}
                                            obrigatorio
                                            titulo="Email"
                                            valor={this.state.dadosEndereco.NO_EMAIL}
                                            tituloClassName={"text-primary"}
                                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                                        />
                                    </Col>
                                </Row>
                            </Box>
                        </Col>
                    </Row>


                    <Alerta ref={this.alert} tipo={TipoAlerta.danger} padraoFormulario />
                    <Botao icone={"fa fa-save"} onClick={this.validar} titulo={"Salvar"} submit />
                </Form>

                <ToastContainer />

            </Page>
        );
    }

}